import defaultConfig from './dev'

const config = {
  DEV: false,
  MEDIA_ROOT: '/video/',
}

export default { ...defaultConfig, ...config }
